import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import BookingFlow from "./pages/BookingFlow";
import AllServicesPage from "./pages/AllServicesPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/book/:serviceId" element={<BookingFlow />} />
          <Route path="/all-services" element={<AllServicesPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;